// Pipelines, stages and lost reasons of the deals (task 1.7, D-036).
export const tenaxDealsEnglishMessages = {
  resources: {
    deals: {
      fields: {
        pipeline_id: "Pipeline",
        lost_reason_id: "Lost reason",
        next_action_at: "Next action",
      },
    },
  },
  tenax: {
    deals: {
      pipeline: "Pipeline",
      new: "New deal",
      move: "Move",
      move_to: "Move to",
      show_more: "Show %{smart_count} more (%{shown} of %{total})",
      next_action: {
        title: "When is the next action?",
        hint: "An open deal needs a next action date.",
        hint_deal: "%{name}: an open deal needs a next action date.",
        confirm: "Save",
        on: "Next action %{date}",
        overdue: "Next action %{date}, overdue",
        in_stage: "In this stage",
        days: "%{smart_count} day |||| %{smart_count} days",
        days_of_limit:
          "%{smart_count} day of %{max} |||| %{smart_count} days of %{max}",
      },
      default_owner: {
        label: "Owner of the follow-ups of deals without an owner",
        hint: "The automatic follow-ups of deals stuck in a stage go to the deal owner, or to this person.",
        none: "Nobody",
      },
      lost: {
        title: "Why was it lost?",
        hint: "A lost deal needs a reason.",
        hint_deal: "%{name}: a lost deal needs a reason.",
        reason: "Reason",
        choose: "Choose a reason",
        note: "Note (optional)",
        note_required: "Note (required for this reason)",
        confirm: "Mark as lost",
      },
      reasons: {
        title: "Lost reasons",
        hint: "The whole team manages the list. A reason in use is turned off, not deleted.",
        name: "Reason",
        new: "New reason",
        add: "Add",
        move_up: "Move up",
        move_down: "Move down",
        requires_note: "Note required",
        turn_off: "Turn off",
        turn_on: "Turn on",
      },
      stages: {
        title: "Pipelines and stages",
        hint: "A stage with deals can be renamed or moved; it can be removed only when no deal uses it.",
        name: "Stage",
        new: "New stage",
        add: "Add stage",
        move_up: "Move up",
        move_down: "Move down",
        remove: "Remove stage",
        max_days: "Follow-up within (days)",
        is_won: "Won",
        is_lost: "Lost",
        exit_rule: "Exit rule",
        procedure: "Procedure",
        no_procedure: "No procedure",
        in_use: "%{smart_count} deal |||| %{smart_count} deals",
      },
    },
  },
};

export const tenaxDealsItalianMessages = {
  resources: {
    deals: {
      fields: {
        pipeline_id: "Pipeline",
        lost_reason_id: "Motivo della perdita",
        next_action_at: "Prossima azione",
      },
    },
  },
  tenax: {
    deals: {
      pipeline: "Pipeline",
      new: "Nuova trattativa",
      move: "Sposta",
      move_to: "Sposta in",
      show_more: "Mostra altre %{smart_count} (%{shown} di %{total})",
      next_action: {
        title: "Quando è la prossima azione?",
        hint: "Una trattativa aperta ha bisogno della data della prossima azione.",
        hint_deal:
          "%{name}: una trattativa aperta ha bisogno della data della prossima azione.",
        confirm: "Salva",
        on: "Prossima azione %{date}",
        overdue: "Prossima azione %{date}, scaduta",
        in_stage: "In questa fase",
        days: "%{smart_count} giorno |||| %{smart_count} giorni",
        days_of_limit:
          "%{smart_count} giorno su %{max} |||| %{smart_count} giorni su %{max}",
      },
      default_owner: {
        label: "Responsabile dei follow-up delle trattative senza responsabile",
        hint: "I follow-up automatici delle trattative ferme in una fase vanno al responsabile della trattativa, o a questa persona.",
        none: "Nessuno",
      },
      lost: {
        title: "Perché è persa?",
        hint: "Una trattativa persa ha bisogno di un motivo.",
        hint_deal: "%{name}: una trattativa persa ha bisogno di un motivo.",
        reason: "Motivo",
        choose: "Scegli un motivo",
        note: "Nota (facoltativa)",
        note_required: "Nota (obbligatoria per questo motivo)",
        confirm: "Segna come persa",
      },
      reasons: {
        title: "Motivi di perdita",
        hint: "La lista la gestisce tutto il team. Un motivo usato si disattiva, non si cancella.",
        name: "Motivo",
        new: "Nuovo motivo",
        add: "Aggiungi",
        move_up: "Sposta su",
        move_down: "Sposta giù",
        requires_note: "Nota obbligatoria",
        turn_off: "Disattiva",
        turn_on: "Riattiva",
      },
      stages: {
        title: "Pipeline e fasi",
        hint: "Una fase con trattative si rinomina o si sposta; si elimina solo quando nessuna trattativa la usa.",
        name: "Fase",
        new: "Nuova fase",
        add: "Aggiungi fase",
        move_up: "Sposta su",
        move_down: "Sposta giù",
        remove: "Elimina fase",
        max_days: "Follow-up entro (giorni)",
        is_won: "Vinta",
        is_lost: "Persa",
        exit_rule: "Regola di uscita",
        procedure: "Procedura",
        no_procedure: "Nessuna procedura",
        in_use: "%{smart_count} trattativa |||| %{smart_count} trattative",
      },
    },
  },
};
